import { BECOME_OFFLINE, BECOME_ONLINE } from '../actions/types'

interface NetConnectivityStore {
    netCoIsOnline: boolean
}

const INITIAL_STATE: NetConnectivityStore = {
    netCoIsOnline: true,
}

export default (state = INITIAL_STATE, action: any): NetConnectivityStore => {
    switch (action.type) {
        case BECOME_ONLINE:
            return {
                ...state,
                netCoIsOnline: true,
            }
        case BECOME_OFFLINE:
            return {
                ...state,
                netCoIsOnline: false,
            }
        default:
            return state
    }
}
